import { cn } from '@/lib/utils'

interface ContentAreaProps {
	children: React.ReactNode
	className?: string
}

export function ContentArea({ children, className }: ContentAreaProps) {
	return (
		<main
			className={cn(
				"flex-1 overflow-y-auto bg-background",
				className
			)}
		>
			<div className="w-full p-4 md:p-6 lg:p-8">
				{children}
			</div>
		</main>
	)
}
